export default __webpack_public_path__ + "static/media/network_ipv6_24.2981fe72.svg";